var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-row',[_c('b-col',{attrs:{"cols":"12"}},[_c('quill-editor-snow'),_c('quill-editor-bubble'),_c('quill-editor-custom')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }